module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('list', {
    ref: "list",
    staticClass: "bands",
    attrs: {
      "scroll": true,
      "items": _vm.bands,
      "link": "band",
      "fields": ['name', 'country'],
      "type": "std"
    },
    on: {
      "update": _vm.load
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4965f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/BandsByStyle.vue
// module id = 248
// module chunks = 0